



















































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import AgregarCondominio from '@/components/condominios/AgregarCondominio.vue';
import ModificaCondominio from '@/components/condominios/ModificaCondominio.vue';
import Configuraciones from '@/components/condominios/Configuraciones.vue';
import {mapActions} from 'vuex';

export default Vue.extend({
  components: { AgregarCondominio, ModificaCondominio, Configuraciones },
  data: () => ({
    singleSelect: false,
    row: null,
    selected: [],
    isSelectedUnique: false,
    headers: [
      // { text: 'id', value: 'id', sortable: false },
      { text: 'Nombre', value: 'nombre' },
    ],
    total: 0,
    gridData: [],
    loading: true,
    options: {
      sortBy: ['nombre'],
      sortDesc: [false],
    },
    desac: true,
  }),
  mounted() {
    this.clearCondo();
  },
  methods: {
    ...mapActions(['getCondoList', 'setCondo', 'clearCondo']),
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const data = {id: admin.id, options: this.options};
        console.debug('getCondoList data: %o', data);
        const result = await this.$store.dispatch('getCondoList', data);
        console.debug('getCondoList response: %o', result.content);
        this.gridData = result.content;
        this.total = result.totalElements;
      } catch (e) {
        console.debug('getCondoList error: %o', e);
        // this.$toast.error(e);
        this.$toast.error('Administración no seleccionada');
      }
      this.loading = false;
    },
    AdminCondo() {
      this.$router.push({name: 'AdminCondo'});
    },
    Adminback() {
      this.$router.push({name: 'administraciones'});
    },
    rowSelected(event) {
      this.row = event;
      this.$router.push({name: 'condominio', params: {condominio: event}});
      this.setCondo(event);
    },
    pageEventHandler(page) {
      this.loadData();
    },
    reloadGrid(event) {
      this.loadData();
    },
  },
  watch: {
    selected() {
      if (this.selected.length === 0) {
        this.isSelectedUnique = false;
      } else {
        this.isSelectedUnique = true;
      }
    },
  },
});
